import styled, { css } from 'styled-components';
import { onSurface, onSurfaceVariant, primary, radiusFull, surfaceHigh } from '../themeTokens';

const BAR_SIZES = {
  regular: { height: 32, padding: '0 8px 0 12px', fontSize: 13 },
  narrow: { height: 26, padding: '0 4px 0 8px', fontSize: 12 },
} as const;

const barTone = (narrow: boolean) => {
  const size = BAR_SIZES[narrow ? 'narrow' : 'regular'];
  return css`
    height: ${size.height}px;
    padding: ${size.padding};
    font-size: ${size.fontSize}px;
    font-weight: 500;
    color: ${onSurface};
  `;
};

const readoutTone = css`
  padding: 4px 8px;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: ${onSurfaceVariant};
`;

export const Pill = styled.button<{ $tone: 'bar' | 'readout'; $narrow: boolean; $open: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 0;
  border-radius: ${radiusFull};
  white-space: nowrap;
  cursor: pointer;
  background: ${(p) => (p.$open ? surfaceHigh(p) : 'transparent')};
  transition: background 120ms ease, color 120ms ease;

  ${({ $tone, $narrow }) => ($tone === 'bar' ? barTone($narrow) : readoutTone)}

  &:hover {
    background: ${surfaceHigh};
    color: ${onSurface};
  }

  &:focus-visible {
    outline: 2px solid ${primary};
    outline-offset: 1px;
  }

  & > svg {
    flex: none;
    font-size: 1em;
  }
`;
